import { render, staticRenderFns } from "./release_index.vue?vue&type=template&id=5759c185&scoped=true"
import script from "./release_index.vue?vue&type=script&lang=js"
export * from "./release_index.vue?vue&type=script&lang=js"
import style0 from "./release_index.vue?vue&type=style&index=0&id=5759c185&prod&scoped=true&lang=less"
import style1 from "./release_index.vue?vue&type=style&index=1&id=5759c185&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5759c185",
  null
  
)

export default component.exports